import Phaser from 'phaser';
import { Elevator } from '../../../common/enums/elevator';
import { imageSize } from '../../../common/data/config';
import { Size } from '../../../common/types/size';

export class ElevatorView extends Phaser.GameObjects.Container {
  private elevatorFrameSize: Size = {
    w: 375,
    h: 575,
  };
  private elevatorSize: Size = {
    w: 252,
    h: 536,
  };
  private elevatorDoorSize: Size = {
    w: 125,
    h: 538,
  };
  private toiletSize: Size = {
    w: 135,
    h: 258,
  };
  private elevatorLeftPosition = 25;
  private elevatorFrameSideWidth =
    (this.elevatorFrameSize.w - this.elevatorDoorSize.w * 2) / 2;
  private elevatorDoorLeftPosition =
    this.elevatorLeftPosition + this.elevatorFrameSideWidth;
  private leftDoorSprite!: Phaser.GameObjects.Sprite;
  private rightDoorSprite!: Phaser.GameObjects.Sprite;

  private leftDoorClosedX!: number;
  private rightDoorClosedX!: number;
  private leftDoorOpenX!: number;
  private rightDoorOpenX!: number;

  private shouldBeClosing!: boolean;
  private toiletShouldBeHide!: boolean;
  private toiletImage!: Phaser.GameObjects.Image;

  constructor(scene: Phaser.Scene) {
    super(scene);
    this.init();
  }

  public playElevatorDoorAnim(isOpening: boolean): void {
    this.scene.tweens.add({
      targets: this.leftDoorSprite,
      x: isOpening ? this.leftDoorOpenX : this.leftDoorClosedX,
      duration: 2500,
      ease: Phaser.Math.Easing.Expo.InOut,
    });
    this.scene.tweens.add({
      targets: this.rightDoorSprite,
      x: isOpening ? this.rightDoorOpenX : this.rightDoorClosedX,
      duration: 2500,
      ease: Phaser.Math.Easing.Expo.InOut,
      onComplete: () => this.toggleElevatorAnimation(),
    });
  }

  private init(): void {
    this.initElevator();
    this.createElevatorSpriteAndPlayAnimation();
    this.initElevatorDoors();
  }

  private initElevator(): void {
    this.scene.add
      .image(
        this.elevatorLeftPosition +
          (this.elevatorFrameSize.w - this.elevatorSize.w) / 2,
        imageSize.h - this.elevatorSize.h,
        Elevator.Inside
      )
      .setOrigin(0, 0);
    this.scene.add
      .image(
        this.elevatorLeftPosition,
        imageSize.h - this.elevatorFrameSize.h,
        Elevator.Frame
      )
      .setOrigin(0, 0);
    this.toiletImage = this.scene.add
      .image(
        this.elevatorFrameSize.w / 2 -
          this.toiletSize.w / 2 +
          this.elevatorLeftPosition,
        imageSize.h - this.toiletSize.h,
        Elevator.Toilet
      )
      .setOrigin(0, 0);
  }

  private createElevatorSpriteAndPlayAnimation(): void {
    const doorTopPosition =
      imageSize.h -
      this.elevatorFrameSize.h +
      this.elevatorFrameSize.h -
      this.elevatorDoorSize.h;
    this.leftDoorSprite = this.scene.add
      .sprite(this.elevatorDoorLeftPosition, doorTopPosition, Elevator.DoorLeft)
      .setOrigin(0, 0);
    this.rightDoorSprite = this.scene.add
      .sprite(
        this.elevatorDoorLeftPosition + this.elevatorDoorSize.w,
        doorTopPosition,
        Elevator.DoorRight
      )
      .setOrigin(0, 0);
    this.scene.anims.create({
      key: Elevator.DoorLeft,
      frames: Elevator.DoorLeft,
      frameRate: 9,
      repeat: -1,
    });
    this.scene.anims.create({
      key: Elevator.DoorRight,
      frames: Elevator.DoorRight,
      frameRate: 9,
      repeat: -1,
    });
    this.leftDoorClosedX = this.leftDoorSprite.x;
    this.leftDoorOpenX =
      this.elevatorLeftPosition - this.elevatorFrameSideWidth;
    this.rightDoorClosedX = this.rightDoorSprite.x;
    this.rightDoorOpenX =
      this.elevatorLeftPosition +
      this.elevatorDoorSize.w * 2 +
      this.elevatorFrameSideWidth;
  }

  private initElevatorDoors() {
    const mask = this.scene.make
      .graphics({})
      .fillRect(
        this.elevatorDoorLeftPosition,
        imageSize.h - this.elevatorDoorSize.h,
        this.elevatorDoorSize.w * 2,
        this.elevatorDoorSize.h
      )
      .createGeometryMask();
    this.leftDoorSprite.setMask(mask);
    this.rightDoorSprite.setMask(mask);
  }

  private toggleElevatorAnimation(): void {
    this.shouldBeClosing = !this.shouldBeClosing;
    if (!this.shouldBeClosing) {
      this.toiletShouldBeHide = !this.toiletShouldBeHide;
      this.toiletImage.setVisible(!this.toiletShouldBeHide);
    }
    this.scene.time.addEvent({
      delay: 3000 + 4000 * Math.random(),
      callback: () => this.playElevatorDoorAnim(!this.shouldBeClosing),
    });
  }
}
